import { createAction } from 'redux-actions';
import * as actionType from './actionTypes';

const setSearchUser = createAction(actionType.SET_SEARCH_USER);
const clearSearchUser = createAction(actionType.CLEAR_SEARCH_USER);

export { setSearchUser, clearSearchUser };
